import { SlingoEvent } from "@lib/titan2-slingo/dist/game/controller/event/SlingoEvent";
import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import { Clock } from "@lib/titan2/dist/game/control/Clock";
import { TitanSprite } from "@lib/titan2/dist/game/control/TitanSprite";
import { TitanText } from "@lib/titan2/dist/game/control/TitanText";
import { CommonGameEvent } from "@lib/titan2/dist/game/controller/event/CommonGameEvent";
import { CommonLang } from "@lib/titan2/dist/game/view/lang/CommonLang";
import { KeyValuePair } from "@lib/titan2/dist/util/collection/KeyValuePair";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { GameLang } from "../lang/GameLang";
/**
 * GameMessageBar.ts
 */
export class GameTopBar extends AbstractGameView {
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(CommonGameEvent.PURCHASE_ENTRY, this.updateGameId);
        this.registerGame(CommonGameEvent.START_GAME, this.updateGameId);
        this.registerGame(CommonGameEvent.STANDARD_SPIN_RECOVERY, this.updateGameId);
        this.registerGame(CommonGameEvent.FREE_SPIN_RECOVERY, this.updateGameId);
        this.registerGame(CommonGameEvent.STAKE_UPDATED, this.updateGameId);
        this.registerCore(CommonGameEvent.BALANCE_UPDATED, this.updateGameId);
        this.registerGame(CommonGameEvent.PURCHASE_SPIN, this.updateGameId);
        this.registerGame(CommonGameEvent.PURCHASE_SPIN_RECOVERY, this.updateGameId);
        this.registerGame(SlingoEvent.BALANCE_UPDATE, this.updateGameId);
    }
    create() {
        super.create();
        this.data = this.factory.createMessageBarData();
        this.createBackground();
        this.createGameIdField();
        this.createClock();
        this.createMessageBar();
        Logger.addObjectRef(this, "GameTopBar");
    }
    updateGameId() {
        if (this.gameId) {
            let gameId = this.model.getGameInstanceId();
            if (gameId > 0) {
                let params = [new KeyValuePair(CommonLang.PARAM_AMOUNT, gameId)];
                let message = this.langManager.getLang(GameLang.BOTTOM_BAR_GAME_ID, params);
                this.gameId.setText(message);
            }
            else {
                this.gameId.clear();
            }
        }
    }
    createBackground() {
        this.background = new TitanSprite(this.landscapeProperties.backgroundProperties, this.portraitProperties?.backgroundProperties);
        this.background.x = this.renderer.getViewport().width / 2;
        this.addChild(this.background);
    }
    createClock() {
        this.clock = new Clock(this.landscapeProperties.clockProperties, this.portraitProperties?.clockProperties);
        this.addChild(this.clock);
    }
    createGameIdField() {
        if (this.uiProperties.gameIdProperties) {
            this.gameId = TitanText.createField(this, this.landscapeProperties.gameIdProperties, this.portraitProperties?.gameIdProperties);
            this.addChild(this.gameId);
        }
    }
    createMessageBar() {
        this.messageBar = this.factory.createMessageBar();
        this.addChild(this.messageBar);
    }
    handleResize(event) {
        const transFormedScale = this.getTransformedScale(this, this.scale);
        const renderView = this.renderer.getView();
        const renderWidth = parseInt(renderView.style.width, 10) || renderView.width;
        const distanceToTop = 0 - this.getGlobalPosition().y;
        const distanceToLeft = 0 - this.gameId?.getGlobalPosition().x;
        const distanceToRight = renderWidth - this.clock?.getGlobalPosition().x;
        //Frustratingly, you can't detect fullscreen if the game is in an iframe. The only solution is to force the offset at all times.
        const fullScreenOffset = this.uiProperties.fullScreenOffset; // document.fullscreenElement ? this.uiProperties.fullScreenOffset : 0;
        this.y += distanceToTop / transFormedScale.y;
        if (this.gameId)
            this.gameId.x += distanceToLeft / transFormedScale.x + this.uiProperties.fieldOffset + fullScreenOffset;
        if (this.clock)
            this.clock.x += distanceToRight / transFormedScale.x - this.uiProperties.fieldOffset - fullScreenOffset;
        if (this.background)
            this.background.width = renderWidth / transFormedScale.x;
    }
}
//# sourceMappingURL=GameTopBar.js.map